<div *ngIf="editing">
  <form class="form-horizontal" (ngSubmit)="onUpdate()">
    <div class="input-selector">
      <div class="input-selector-text">
        <input
          required
          class="form-control"
          autofocus="true"
          [type]="type"
          [value]="stringValue"
          [(ngModel)]="model"
          name="input"
          [min]="min"
          [max]="max"
        />
      </div>
      <div class="input-selector-button">
        <button class="btn btn-success btn-sm btn-icon" (click)="onUpdate()">
          <fa-icon [icon]="['fal', 'check']"></fa-icon>
        </button>
        <button class="btn btn-sm btn-icon" (click)="onCancel()">
          <fa-icon [icon]="['fal', 'times']"></fa-icon>
        </button>
        <button *ngIf="deletable" class="btn btn-danger btn-sm btn-icon" (click)="onDelete()">
          <fa-icon [icon]="['fal', 'trash']"></fa-icon>
        </button>
      </div>
    </div>
  </form>
</div>
<div *ngIf="!editing" style="cursor: pointer" (click)="onEdit()">{{ stringValue }}</div>
